import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import { useParams, useHistory } from 'react-router';
import { toast } from 'react-toastify';
import Api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import { partial } from '../../util/translation/translation';
import QuestionaireCategoryForm from './components/QuestionaireCategoryForm';
import NavTab from '../../shared/components/custom/NavTab';
import QuestionaireCategoryLeaderboardPage from './components/QuestionaireCategoryLeaderboardPage';

const QuestionaireCategoryFormPage = () => {
  const { questionaireCategoryID } = useParams();
  const [tab, setTab] = useState('0');
  const history = useHistory();
  const [questionaireCategory, setQuestionaireCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const p = partial('questionaire');
  const s = partial('shared');

  const getQuestionaireCategory = async () => {
    setLoading(true);
    try {
      const resQuestionaireCategory =
        await Api.questionaire.categories.getQuestionaireCategory(
          questionaireCategoryID
        );
      setQuestionaireCategory(resQuestionaireCategory);
      setLoading(false);
    } catch (err) {
      toast.error(JSON.stringify(err));
      setLoading(false);
    }
  };

  useEffect(() => {
    if (questionaireCategoryID) {
      getQuestionaireCategory();
    }
  }, [questionaireCategoryID]);

  const onQuestionaireCategorySubmit = async (values, questionValue) => {
    const payload = {
      title: values.title,
      description: values.description,
      image: values.headingImage.croppedBase64 || values.headingImage.preview,
    };
    setLoading(true);
    try {
      if (questionaireCategoryID) {
        await Api.questionaire.categories.updateQuestionaireCategory(
          questionaireCategoryID,
          payload
        );
      } else {
        await Api.questionaire.categories.createQuestionaireCategory(payload);
      }
      history.push('/questionnaires?tab=3');
      toast.success(p('questionUpdated'));
    } catch (err) {
      toast.error(err || s('somethingWentWrong'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Loading loading={loading} />
      <Row>
        <Col>
          <Card>
            <CardBody className="p-0">
              <NavTab
                tabs={[{ tab: s('details') }, { tab: p('leaderboard') }]}
                activeTab={tab}
                setTab={setTab}
                size="sm"
              />
              <TabContent activeTab={tab}>
                <TabPane tabId="1" className="m-3">
                  <QuestionaireCategoryForm
                    isEdit={!!questionaireCategoryID}
                    questionaireCategory={questionaireCategory}
                    onSubmit={onQuestionaireCategorySubmit}
                  />
                </TabPane>
                <TabPane tabId="2" className="m-3">
                  <QuestionaireCategoryLeaderboardPage
                    categoryId={questionaireCategoryID}
                    title={questionaireCategory?.title}
                  />
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default QuestionaireCategoryFormPage;
